// @ts-nocheck
export function generateColorFromString(rawStr) {
  const str = rawStr ?? '';

  let hash = 0;

  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Convert the hash to a hexadecimal color code
  let color = (hash & 0x00ffffff).toString(16).toUpperCase();

  // Add leading zeros if necessary
  while (color.length < 6) {
    color = '0' + color;
  }

  // Prepend a '#' to the color code
  color = '#' + color;

  return color;
}
